import { render, staticRenderFns } from "./IdentityVerificationSectionNonFace.vue?vue&type=template&id=41de3ace&scoped=true&"
import script from "./IdentityVerificationSectionNonFace.vue?vue&type=script&lang=js&"
export * from "./IdentityVerificationSectionNonFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de3ace",
  null
  
)

export default component.exports